import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import OutletSearch from "../SelectSearch/OutletSearch";
import { FaTrashAlt } from 'react-icons/fa';

const MessageTemplate = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const [selectedOutlet, setSelectedOutlet] = useState("");
    const [currentTemplate, setCurrentTemplate] = useState("");
    const [newTemplate, setNewTemplate] = useState("");
    const token = localStorage.getItem("token");

    useEffect(() => {
        fetchTemplate();
    }, [selectedOutlet, baseUrl, token]);

    const fetchTemplate = async () => {
        if (!selectedOutlet) return;

        try {
            const res = await axios.post(`${baseUrl}/get-sms-template`, {
                outlet_name: selectedOutlet,
                token: token,
            });

            const text = res.data?.sms_text || "";
            setCurrentTemplate(text);
        } catch (error) {
            toast.error("Failed to load template");
        }
    };

    const handleUpdate = async () => {
        if (!selectedOutlet) {
            toast.warning("Select an outlet first");
            return;
        }

        try {
            await axios.post(`${baseUrl}/update-sms-template`, {
                outlet_name: selectedOutlet,
                token: token,
                sms_text: newTemplate,
            });

            toast.success("Template updated successfully");
            setNewTemplate("");
            fetchTemplate();
        } catch (error) {
            toast.error("Failed to update template");
        }
    };

    const handleClearTemplate = () => {
        if (!selectedOutlet) {
            toast.warning("Select an outlet first");
            return;
        }

        toast.dismiss();

        toast.info(
            <div>
                <p>Are you sure you want to delete this template?</p>

                <div className="flex gap-2 mt-2">
                    <button
                        className="px-3 py-1 bg-red-600 text-white rounded"
                        onClick={async () => {
                            try {
                                await axios.post(`${baseUrl}/clear-sms-template`, {
                                    outlet_name: selectedOutlet,
                                    token: token,
                                });

                                setCurrentTemplate("");
                                setNewTemplate("");
                                toast.success("Template cleared");
                            } catch (err) {
                                toast.error("Failed to clear template");
                            }
                        }}
                    >
                        Yes
                    </button>

                    <button
                        className="px-3 py-1 bg-gray-600 rounded"
                        onClick={() => toast.dismiss()}
                    >
                        No
                    </button>
                </div>
            </div>,
            { autoClose: false }
        );
    };

    return (
        <div className="p-5 bg-white shadow rounded-lg space-y-5">

            <OutletSearch
                selectedOutlet={selectedOutlet}
                setSelectedOutlet={setSelectedOutlet}
                token={token}
            />

            {selectedOutlet && (
                <>
                    <div>
                        <div className="flex items-center justify-between mb-1">
                            <label className="font-semibold">Current Template</label>

                            <button
                                className="p-2 text-sm border rounded flex items-center justify-center text-red-600 hover:bg-red-50"
                                onClick={handleClearTemplate}
                            >
                                <FaTrashAlt />
                            </button>
                        </div>
                        <div className="w-full border rounded p-3 bg-gray-50 text-sm min-h-[80px] whitespace-pre-wrap">
                            {currentTemplate || "No template found for this outlet."}
                        </div>
                    </div>

                    <div>
                        <label className="font-semibold mb-1">Update Template</label>
                        <textarea
                            className="w-full border rounded p-3"
                            rows={8}
                            value={newTemplate}
                            onChange={(e) => setNewTemplate(e.target.value)}
                            placeholder="Enter new SMS template..."
                        />
                    </div>

                    <button
                        className="px-4 py-2 rounded-sm bg-purple-100 text-purple-800 hover:bg-purple-200 text-sm"
                        onClick={handleUpdate}
                    >
                        Save Template
                    </button>
                </>
            )}
        </div>
    );
};

export default MessageTemplate;
